import { Action } from '@ngrx/store';
import { NavigationExtras } from '@angular/router';

export enum ERouterActions {
    ROUTER_GO = '[Router] Go',
    ROUTER_BACK = '[Router] Back',
    ROUTER_CHANGE = '[Router] Change',
}

export class RouterGo implements Action {
    readonly type = ERouterActions.ROUTER_GO;

    constructor(
        public payload: {
            path: any[];
            queryParams?: object;
            extras?: NavigationExtras;
        },
    ) {}
}

export class RouterBack implements Action {
    readonly type = ERouterActions.ROUTER_BACK;
}

export class RouteChange implements Action {
    readonly type = ERouterActions.ROUTER_CHANGE;
    constructor(public payload: { params: any; path: string }) {}
}

export type RouterUnionAction = RouterGo | RouterBack | RouteChange;
